<template>
  <div id="promocodes-title" v-if="isShow">
    <h2 class="page-title" v-html="getTitle()"></h2>
  </div>
</template>

<script setup>
import {onMounted, reactive, ref, watch} from "vue"
import {useRouter} from "vue-router"
import "./css/style.css"

const isShow = ref(false)

const router = useRouter()

const props = defineProps({
  payload: {
    type: Object,
    default: () => ({}),
  },
})

const fields = reactive({
  pageRoot: false,
  title: 0,
})

watch(() => props.payload, (val) => {
  updateFields(val)
}, {
  immediate: true,
})

onMounted(() => {
  isShow.value = true
})

function updateFields(query) {
  fields.title = query.title
  fields.pageRoot = query.page_root
}

function getTitle() {
  let result = ""

  if (!fields.pageRoot) {
    let href = router.resolve({
      name: 'PromocodesListShop',
    }).href

    result += `<a class="page-root me-1" href="${href}">Промокоды</a>`
    result += "- "
  }

  result += fields.title

  return result
}

</script>
